import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;
  private readonly _ready: Promise<void>;

  constructor(private storage: Storage) {
    this._ready = this.storage.create().then((storage) => {
      this._storage = storage;
    });
  }

  /** Resolves when Ionic Storage has finished initializing. */
  ready(): Promise<void> {
    return this._ready;
  }

  private whenReady(): Promise<Storage> {
    return this._ready.then(() => {
      if (!this._storage) {
        throw new Error('Storage failed to initialize');
      }
      return this._storage;
    });
  }

  public set(key: string, value: any): Promise<any> {
    return this.whenReady().then((s) => s.set(key, value));
  }

  public get(key: string): Promise<any> {
    return this.whenReady().then((s) => s.get(key));
  }

  public remove(key: string): Promise<any> {
    return this.whenReady().then((s) => s.remove(key));
  }
}
